import { createFileRoute } from '@tanstack/react-router';
import { PublicSigningScreen } from '../features/signing/public-signing-screen';

/**
 * Pagina publică de semnare. **În afara stratului `_authenticated`**, deliberat.
 *
 * Clientul n-are cont și nu trebuie să aibă: singura lui credențială e tokenul din URL.
 * Fișierul stă în rădăcina rutelor, nu în `_authenticated/`, deci nu moștenește nici
 * verificarea de sesiune, nici antetul cu meniu — vezi `routes/login.tsx`, care e acolo
 * din același motiv.
 *
 * Adresa e cea din `CRM_PUBLIC_URL`, pe server: linkul din email se construiește acolo,
 * niciodată din antetul `Host` al cererii.
 */
export const Route = createFileRoute('/semnare/$token')({
  component: SigningPage,
});

function SigningPage() {
  const { token } = Route.useParams();

  return <PublicSigningScreen token={token} />;
}
